import React from "react";
import { useTranslation } from "react-i18next";
import servicesData from "../data/servicesData";

export default function ServicesSection() {
  const { t } = useTranslation();

  const showData = servicesData.map((el, index) => {
    return (
      <div
        key={index}
        className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col gap-[20px] border border-[#3896BE]/20"
      >
        <div className="mb-4">
          <img
            src={el.icon}
            alt={el.title}
            className="w-16 h-16 object-contain"
          />
        </div>
        <div className="mb-3">
          <div className="text-xl font-semibold text-[#3896BE]">
            {t(el.title)}
          </div>
          <p className="text-sm text-gray-600 leading-relaxed mt-2">
            {t(el.details)}
          </p>
        </div>
      </div>
    );
  });

  return (
    <>
      <section className="relative py-[40px]">
        <div className="container flex flex-col gap-[30px]">
          <div className="flex flex-col items-center justify-center gap-[8px] text-center">
            <h2 className="text-[35px] font-bold text-[#3896BE] capitalize">
              {t("Our Services")}
            </h2>
            <div className="flex flex-col gap-[3px] justify-center items-center">
              <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
              <span className="bg-[#3896BE] flex w-[250px] h-[4px]"></span>
              <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {showData}
          </div>
        </div>
      </section>
    </>
  );
}
